import { render, staticRenderFns } from "./learnerReviews.vue?vue&type=template&id=5a6856d7&scoped=true&"
import script from "./learnerReviews.vue?vue&type=script&lang=ts&"
export * from "./learnerReviews.vue?vue&type=script&lang=ts&"
import style0 from "./learnerReviews.vue?vue&type=style&index=0&id=5a6856d7&lang=scss&scoped=true&"
import style1 from "./learnerReviews.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6856d7",
  null
  
)

export default component.exports